'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _selectors = require('../../../../store/selectors');

var _helpers = require('../../../../helpers/');

var _constants = require('../../../../constants');

var _ValidationInputs = require('./ValidationInputs');

var _ValidationInputs2 = _interopRequireDefault(_ValidationInputs);

require('./Task.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var find = require('lodash/collection/find');

var FormItem = _antd.Form.Item;
var Option = _antd.Select.Option;

var Task = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(Task, _React$Component);

  function Task() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Task);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Task.__proto__ || (0, _getPrototypeOf2.default)(Task)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      form: {}
    }, _this.getConditionalHelperText = function (action) {
      var helperText = void 0;
      switch (action) {
        case 'CHANGE_BID':
          {
            var aggregationLevel = _this.props.ruleSettings.aggregationLevel;

            var foundAggregationLevel = _constants.AGGREGATION_LEVELS.find(function (aggregationLevelObject) {
              return aggregationLevelObject.value === aggregationLevel;
            });
            if (foundAggregationLevel) {
              if (_this.state.form.actionValueFlag === 'INCREASE') {
                helperText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.bid.increase.helper.text',
                  defaultMessage: 'Bid increases will not be applied to {aggregationLevel} that uses auto bidding.',
                  values: { aggregationLevel: foundAggregationLevel.label }
                });
              } else if (_this.state.form.actionValueFlag === 'DECREASE') {
                helperText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.bid.decrease.helper.text',
                  defaultMessage: 'Bid decreases will not be applied to {aggregationLevel} that uses auto bidding.',
                  values: { aggregationLevel: foundAggregationLevel.label }
                });
              }
            }
            break;
          }
        default:
          break;
      }
      return helperText;
    }, _this.actionChange = function (value) {
      var _this$props = _this.props,
          ruleBranchID = _this$props.ruleBranchID,
          task = _this$props.task,
          builderActions = _this$props.builderActions;


      var newFormState = {
        action: value,
        actionValue: null,
        actionValueBound: null,
        actionValueUnit: null,
        actionValueFlag: null
      };
      _this.setState({
        form: newFormState,
        isValid: null
      }, function () {
        builderActions('updateEntitiesValidation', {
          ruleBranches: ruleBranchID,
          tasks: task.id
        }, true);
      });
    }, _this.getFieldsForAction = function (action) {
      if (!action) return null;
      var fields = [];
      switch (action) {
        case 'CHANGE_STATE':
          {
            fields = [{
              id: 'change_state',
              name: 'actionValue',
              format: 'select',
              children: [{
                value: 'ACTIVE',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.change.status.dropdown.option.active.label',
                  defaultMessage: 'Active'
                })
              }, {
                value: 'PAUSED',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.change.status.dropdown.option.pause.label',
                  defaultMessage: 'Pause'
                })
              }],
              decorator: {
                rules: [{
                  required: true,
                  message: 'Missing value'
                }],
                initialValue: _this.state.form.actionValue
              }
            }];
            if (_this.state.form.actionValue === 'ACTIVE') {
              fields.push({
                id: 'manual_override',
                name: 'actionValueFlag',
                format: 'checkbox',
                props: {
                  defaultChecked: _this.state.form.actionValueFlag && _this.state.form.actionValueFlag === 'MANUAL'
                },
                children: [_react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.manualOverride.label',
                  key: 'manual-override-label',
                  defaultMessage: 'Manual override '
                }), _react2.default.createElement(
                  _antd.Tooltip,
                  {
                    key: 'manual-override-tooltip',
                    placement: 'top',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: 'task.manualOverride.tooltip',
                      defaultMessage: 'Enable permission to activate entities which have been manually paused by a user (i.e., to override the manually applied status).'
                    })
                  },
                  _react2.default.createElement(_antd.Icon, { type: 'question-circle-o' })
                )]
              });
            }
            break;
          }
        case 'CHANGE_BUDGET':
        case 'CHANGE_BID':
          {
            var currentActionValueFlagValue = _this.state.form.actionValueFlag;
            fields = [{
              id: 'change_bid_type',
              name: 'actionValueFlag',
              format: 'select',
              decorator: {
                initialValue: _this.state.form.actionValueFlag,
                rules: [{
                  required: true,
                  message: 'Missing value'
                }]
              },
              children: [{
                value: 'SET',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.change.types.dropdown.option.set.label',
                  defaultMessage: 'Set'
                })
              }, {
                value: 'INCREASE',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.change.types.dropdown.option.increase.label',
                  defaultMessage: 'Increase'
                })
              }, {
                value: 'DECREASE',
                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.change.types.dropdown.option.decrease.label',
                  defaultMessage: 'Decrease'
                })
              }]
            }];

            switch (currentActionValueFlagValue) {
              case 'SET':
                {
                  fields.push({
                    id: 'change_bid_budget_set',
                    name: 'actionValue',
                    format: 'currency',
                    decorator: {
                      rules: [{
                        required: true,
                        message: 'Missing value'
                      }],
                      type: 'number',
                      initialValue: _this.state.form.actionValue
                    },
                    formItem: {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'task.change.set.label',
                        defaultMessage: 'to'
                      })
                    }
                  });
                  break;
                }
              case 'INCREASE':
                {
                  fields.push({
                    id: 'change_bid_budget_by',
                    name: 'actionValue',
                    format: 'integer',
                    formItem: {
                      label: 'by'
                    },
                    decorator: {
                      rules: [{
                        required: true,
                        message: 'Missing value'
                      }],
                      type: 'number',
                      initialValue: _this.state.form.actionValue ? parseFloat(_this.state.form.actionValue) : null
                    },
                    props: {
                      min: 0
                    },
                    buddy: {
                      id: 'change_bid_budget_by_unit',
                      name: 'actionValueUnit',
                      format: 'select',
                      decorator: {
                        rules: [{
                          required: true,
                          message: 'Missing value'
                        }],
                        initialValue: _this.state.form.actionValueUnit ? _this.state.form.actionValueUnit : 'DOLLAR'
                      },
                      children: [{
                        label: '$',
                        value: 'DOLLAR'
                      }, {
                        label: '%',
                        value: 'PERCENT'
                      }]
                    }
                  });
                  fields.push({
                    id: 'change_bid_budget_bound',
                    name: 'actionValueBound',
                    format: 'currency',
                    formItem: {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'task.change.maximum.label',
                        defaultMessage: 'to a maximum of'
                      })
                    },
                    decorator: {
                      rules: [{
                        required: false
                      }],
                      type: 'number',
                      initialValue: _this.state.form.actionValueBound ? parseFloat(_this.state.form.actionValueBound) : null
                    }
                  });
                  break;
                }
              case 'DECREASE':
                {
                  fields.push({
                    id: 'change_bid_budget_by',
                    name: 'actionValue',
                    format: 'integer',
                    formItem: {
                      label: 'by'
                    },
                    decorator: {
                      rules: [{
                        required: true,
                        message: 'Missing value'
                      }],
                      type: 'number',
                      initialValue: _this.state.form.actionValue ? parseFloat(_this.state.form.actionValue) : null
                    },
                    props: {
                      min: 0
                    },
                    buddy: {
                      id: 'change_bid_budget_by_unit',
                      name: 'actionValueUnit',
                      format: 'select',
                      decorator: {
                        rules: [{
                          required: true,
                          message: 'Missing value'
                        }],
                        initialValue: _this.state.form.actionValueUnit ? _this.state.form.actionValueUnit : 'DOLLAR'
                      },
                      children: [{
                        label: '$',
                        value: 'DOLLAR'
                      }, {
                        label: '%',
                        value: 'PERCENT'
                      }]
                    }
                  });
                  fields.push({
                    id: 'change_bid_budget_bound',
                    name: 'actionValueBound',
                    format: 'currency',
                    formItem: {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'task.change.minimum.label',
                        defaultMessage: 'to a minimum of'
                      })
                    },
                    decorator: {
                      rules: [{
                        required: false
                      }],
                      type: 'number',
                      initialValue: _this.state.form.actionValueBound ? parseFloat(_this.state.form.actionValueBound) : null
                    }
                  });
                  break;
                }
              default:
                {
                  break;
                }
            }
            break;
          }
        case 'NOTIFY':
          {
            var parsedDefaultValue = void 0;
            if (_this.state.form.actionValue && _this.state.form.actionValue !== '') {
              if (_this.state.form.actionValue.indexOf(',') > -1) {
                parsedDefaultValue = _this.state.form.actionValue.split(',');
              } else {
                parsedDefaultValue = [_this.state.form.actionValue];
              }
            } else {
              parsedDefaultValue = [];
            }
            fields = [{
              id: 'notify_email_addresses',
              name: 'actionValue',
              format: 'select',
              props: {
                mode: 'tags',
                style: {
                  width: 200
                },
                className: "select-tags-show-whitespace"
              },
              formItem: {
                label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'task.notify.emails.label',
                  defaultMessage: 'Email addresses'
                })
              },
              children: _this.props.users.data,
              decorator: {
                rules: [{
                  required: true,
                  message: 'Missing value'
                }],
                initialValue: parsedDefaultValue
              }
            }];
            break;
          }
        default:
          break;
      }
      return fields;
    }, _this.isFormValid = function () {
      if (typeof _this.state.isValid !== 'undefined') return _this.state.isValid;
      return (0, _helpers.isTaskValid)(_this.state.form, _this.props.ruleSettings.aggregationLevel);
    }, _this.onValidationInputsChange = function (values) {
      if (values) {
        var parsed = (0, _assign2.default)({}, values);
        if (_this.state.form.action === 'CHANGE_STATE') {
          if (parsed.actionValue) {
            if (parsed.actionValue === 'PAUSED') {
              parsed.actionValueFlag = null;
            }
          }
          if (typeof values.actionValueFlag !== 'undefined') {
            parsed.actionValueFlag = values.actionValueFlag === true ? 'MANUAL' : null;
          }
        } else if (_this.state.form.action === 'NOTIFY') {
          if (values.actionValue && values.actionValue.length && values.actionValue.length > 0) {
            parsed.actionValue = values.actionValue.join(',');
          }
        } else if (_this.state.form.action === 'CHANGE_BID' || _this.state.form.action === 'CHANGE_BUDGET') {
          if (values.actionValueFlag && _this.state.form.actionValueFlag !== values.actionValueFlag) {
            parsed.actionValue = null;
            parsed.actionValueUnit = 'DOLLAR';
            parsed.actionValueBound = null;
          }
        }

        _this.setState({ form: (0, _immutabilityHelper2.default)(_this.state.form, {
            $merge: parsed
          }) });
      }
    }, _this.updateValidationInputsValidation = function (isValid, updateStore, fields) {
      var _this$props2 = _this.props,
          ruleBranchID = _this$props2.ruleBranchID,
          task = _this$props2.task,
          builderActions = _this$props2.builderActions;


      _this.setState({ isValid: isValid }, function () {
        if (updateStore === true) {
          builderActions('updateEntitiesValidation', {
            ruleBranches: ruleBranchID,
            tasks: task.id
          }, isValid);
        }
      });
    }, _this.saveTask = function () {
      var _this$props3 = _this.props,
          task = _this$props3.task,
          taskActions = _this$props3.taskActions,
          ruleBranchID = _this$props3.ruleBranchID;

      var form = (0, _assign2.default)({}, _this.state.form);
      taskActions.cancelEdit(task.id);
      taskActions.update(task.id, ruleBranchID, {
        action: form.action,
        actionValue: form.actionValue,
        actionValueFlag: form.actionValueFlag,
        actionValueBound: form.actionValueBound ? form.actionValueBound : null,
        actionValueUnit: form.actionValueUnit
      });
    }, _this.cancelSaveTask = function () {
      var _this$props4 = _this.props,
          task = _this$props4.task,
          ruleBranchID = _this$props4.ruleBranchID,
          taskActions = _this$props4.taskActions,
          ruleSettings = _this$props4.ruleSettings;
      var id = task.id,
          action = task.action,
          actionValue = task.actionValue,
          actionValueFlag = task.actionValueFlag,
          actionValueBound = task.actionValueBound,
          actionValueUnit = task.actionValueUnit;
      // existing task

      _this.updateValidationInputsValidation(true);
      if ((0, _helpers.isTaskValid)(task, ruleSettings.aggregationLevel)) {
        _this.setState({
          form: {
            action: action,
            actionValue: actionValue,
            actionValueFlag: actionValueFlag,
            actionValueBound: actionValueBound,
            actionValueUnit: actionValueUnit
          }
        }, function () {
          taskActions.cancelEdit(id);
        });
      } else {
        taskActions.remove(ruleBranchID, id);
      }
    }, _this.getFormKey = function () {
      var formKey = _this.state.form.action ? _this.state.form.action : 'task-edit-form';
      if ((_this.state.form.action === 'CHANGE_BID' || _this.state.form.action === 'CHANGE_BUDGET') && _this.state.form.actionValueFlag) {
        formKey += '-' + _this.state.form.actionValueFlag;
      }
      return formKey;
    }, _this.editView = function () {
      var aggregationLevel = _this.props.ruleSettings.aggregationLevel;

      var selectConfig = {
        onChange: _this.actionChange,
        style: {
          width: 150
        },
        placeholder: _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'task.action.select.placeholder',
          defaultMessage: 'Select Action'
        })
      };
      var editActions = _react2.default.createElement(
        'div',
        { className: 'text-align-right' },
        _react2.default.createElement(
          _antd.Button,
          {
            onClick: function onClick() {
              return _this.saveTask();
            },
            type: 'primary',
            className: 'task-save-button',
            disabled: !_this.isFormValid()
          },
          _react2.default.createElement(_antd.Icon, { type: 'check' })
        ),
        _react2.default.createElement(
          _antd.Button,
          {
            onClick: function onClick() {
              return _this.cancelSaveTask();
            },
            type: 'default',
            className: 'task-cancel-save-button'
          },
          _react2.default.createElement(_antd.Icon, { type: 'close' })
        )
      );
      var selectMarkup = void 0;
      var additionalFields = void 0;
      var helperText = void 0;
      var actionFeedback = void 0;

      if (aggregationLevel) {
        var _find = find(_constants.AGGREGATION_LEVELS, function (aggregation) {
          return aggregation.value === aggregationLevel;
        }),
            availableActions = _find.availableActions;

        var actionsOptions = availableActions.map(function (availableActionName) {
          var _AVAILABLE_ACTIONS$fi = _constants.AVAILABLE_ACTIONS.find(function (action) {
            return action.value === availableActionName;
          }),
              label = _AVAILABLE_ACTIONS$fi.label;

          return _react2.default.createElement(
            Option,
            { value: availableActionName, key: availableActionName },
            label
          );
        });

        selectMarkup = _react2.default.createElement(
          _antd.Select,
          (0, _extends3.default)({}, selectConfig, { defaultValue: _this.props.task.action, style: { width: '100%' } }),
          actionsOptions
        );

        actionFeedback = _this.state.form.action && !(0, _helpers.isActionValid)(_this.props.ruleSettings.aggregationLevel, _this.state.form.action) ? {
          validateStatus: 'error',
          help: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'task.aggregationLevel.invalid.action',
            defaultMessage: 'Invalid action for Rule scope.'
          })
        } : null;

        if (!actionFeedback) {
          var fields = _this.getFieldsForAction(_this.state.form.action);
          additionalFields = _react2.default.createElement(_ValidationInputs2.default, {
            'for': _this.state.form.action,
            key: _this.getFormKey(),
            fields: fields,
            onChange: _this.onValidationInputsChange,
            isValid: _this.updateValidationInputsValidation
          });
          helperText = _this.getConditionalHelperText(_this.state.form.action);
        }
      } else {
        selectMarkup = _react2.default.createElement(
          _antd.Tooltip,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'task.aggregationLevel.invalid.actions.dropdown.tooltip',
              defaultMessage: 'Select campaigns to apply rule to first'
            })
          },
          _react2.default.createElement(_antd.Select, (0, _extends3.default)({}, selectConfig, { disabled: true })),
          null
        );
      }
      var helperMarkup = helperText ? _react2.default.createElement(
        _antd.Row,
        null,
        _react2.default.createElement(
          _antd.Col,
          { span: 24, className: 'helper-text' },
          helperText
        )
      ) : null;

      return _react2.default.createElement(
        'div',
        { className: 'edit-view' },
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 20 },
            _react2.default.createElement(
              _antd.Row,
              null,
              _react2.default.createElement(
                _antd.Col,
                { span: 24 },
                _react2.default.createElement(
                  _antd.Row,
                  { type: 'flex', justify: 'start' },
                  _react2.default.createElement(
                    _antd.Col,
                    { span: 4, className: 'm-r-16' },
                    _react2.default.createElement(
                      FormItem,
                      actionFeedback,
                      selectMarkup
                    )
                  ),
                  _react2.default.createElement(
                    _antd.Col,
                    null,
                    additionalFields
                  )
                ),
                _react2.default.createElement(
                  _antd.Row,
                  null,
                  _react2.default.createElement(
                    _antd.Col,
                    { span: 24 },
                    helperMarkup
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _antd.Col,
            { span: 4, className: 'text-align-right' },
            editActions
          )
        )
      );
    }, _this.readOnlyView = function () {
      var _this$props5 = _this.props,
          task = _this$props5.task,
          taskActions = _this$props5.taskActions,
          ruleBranchID = _this$props5.ruleBranchID;


      return _react2.default.createElement(
        _antd.Row,
        null,
        _react2.default.createElement(
          _antd.Col,
          { span: 24, className: 'read-only-view' },
          _react2.default.createElement(
            _antd.Row,
            null,
            _react2.default.createElement(
              _antd.Col,
              { span: 20, className: 'show-white-space' },
              (0, _selectors.taskDescriptionBuilder)({ task: _this.props.task })
            ),
            _react2.default.createElement(
              _antd.Col,
              { span: 4, className: 'text-align-right' },
              _react2.default.createElement(_antd.Button, {
                icon: 'edit',
                size: 'small',
                key: 'task-edit-button',
                className: 'task-edit-button',
                onClick: function onClick() {
                  taskActions.edit(task.id);
                }
              }),
              _react2.default.createElement(_antd.Button, {
                icon: 'close',
                size: 'small',
                key: 'task-remove-button',
                className: 'task-remove-button',
                onClick: function onClick() {
                  taskActions.remove(ruleBranchID, task.id);
                }
              })
            )
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Task, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          taskActions = _props.taskActions,
          task = _props.task;
      var id = task.id,
          action = task.action,
          actionValue = task.actionValue,
          actionValueFlag = task.actionValueFlag,
          actionValueBound = task.actionValueBound,
          actionValueUnit = task.actionValueUnit;


      this.setState({
        form: {
          action: action,
          actionValue: actionValue,
          actionValueFlag: actionValueFlag,
          actionValueBound: actionValueBound,
          actionValueUnit: actionValueUnit
        }
      }, function () {
        // dispatch edit for this condition if the form is invalid
        if (!_this2.isFormValid()) {
          taskActions.edit(id);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          ruleSettings = _props2.ruleSettings,
          editing = _props2.editing,
          taskActions = _props2.taskActions,
          task = _props2.task,
          ruleBranchID = _props2.ruleBranchID;


      if (ruleSettings.aggregationLevel && ruleSettings.aggregationLevel !== nextProps.ruleSettings.aggregationLevel) {
        if (!(0, _helpers.isActionValid)(nextProps.ruleSettings.aggregationLevel, this.state.form.action)) {
          if (!editing) taskActions.edit(task.id);
          this.props.builderActions('updateEntitiesValidation', {
            ruleBranches: ruleBranchID,
            tasks: task.id
          }, false);
        }
      }
    }

    /**
     * Whenever an action changes, we want to reset
     * the state form with the newly updated action,
     * affectively removing all the previous action's
     * fields information as well.
     */


    /**
     * We check if the form is valid here.
     * The condition is considered valid if there is a presence of
     * fact, operator and (valueDecimal OR valueString OR valueJson (needs to not be empty)).
     */

  }, {
    key: 'render',
    value: function render() {
      var editing = this.props.editing;

      var taskBody = void 0;
      if (editing === true) {
        taskBody = this.editView();
      } else {
        taskBody = this.readOnlyView();
      }
      return _react2.default.createElement(
        'div',
        { className: 'task__component' },
        taskBody
      );
    }
  }]);
  return Task;
}(_react2.default.Component), _class.propTypes = {
  ruleSettings: _propTypes2.default.shape({
    aggregationLevel: _propTypes2.default.oneOf(['FB_CAMPAIGN', 'FB_ADSET', 'FB_AD'])
  }).isRequired,
  editing: _propTypes2.default.bool.isRequired,
  ruleBranchID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  task: _propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    action: _propTypes2.default.oneOf(['CHANGE_STATE', 'CHANGE_BID', 'CHANGE_BUDGET', 'NOTIFY'])
  }).isRequired,
  taskActions: _propTypes2.default.shape({
    update: _propTypes2.default.func.isRequired,
    remove: _propTypes2.default.func.isRequired,
    edit: _propTypes2.default.func.isRequired,
    cancelEdit: _propTypes2.default.func.isRequired
  }).isRequired,
  users: _propTypes2.default.shape({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      label: _propTypes2.default.string.isRequired,
      value: _propTypes2.default.string.isRequired
    })).isRequired,
    loading: _propTypes2.default.bool.isRequired
  }).isRequired,
  builderActions: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = Task;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/Task.js
// module id = 3821
// module chunks = 4